import React, { useEffect, useState } from 'react'
import { useLoading } from '../../contexts/LoadingContext';
import { useAuth } from '../../contexts/AuthContext';
import IApiResponse from '../../types/IApiResponse';
import handleApiResponse from '../../utils/handleApiResponse';
import { fetchData } from '../../services/api';
import apiUrls from '../../config/apiUrls';
import LabelText from '../../ui/LabelText';
import { MainContainer } from '../../components/Contents/Contents.element';
import PageHeader from '../../layout/PageHeader';
import './style.css'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useNotification } from '../../contexts/NotificationContext';
import LoadingSpinner from '../../ui/LoadingSpinner';
import { PlayerAvatar } from '../../styled-components/PlayerCard.Styles';
import LabelNumber from '../../styled-components/LabelNumber';
import { ISHortlistData, IShortlistPlayers } from './shortlist';
import { useNavigate } from 'react-router-dom';

const SortListComponent:React.FC<{ toggle: boolean, isSubSidebarOpen: boolean }> = (props) => {
    const { loading , startLoading, stopLoading } = useLoading();
    const { userData } = useAuth();
    const {setDisplayNotification, setNotificationContent} = useNotification();

    const navigate = useNavigate();

    const [sortListPlayerIds, setSortListPlayerIds] = useState<number[]>([]);
    const [showPlayerComparison, setShowPlayerComparison] = useState(false);
    const [playerShortLiastData , setPlayerShortListData] = useState<IShortlistPlayers[]>()

    const [sortListClubIds, setSortListClubIds] = useState<number[]>([]);
    const [showClubComparison, setShowClubComparison] = useState(false);
    const [clubShortLiastData , setClubShortListData] = useState<IShortlistPlayers[]>()

    
    const [isShortListEmpty , setIsShortListEmpty] = useState<boolean>(false)
    const [isclunEmty , setIsclubEmpty] = useState<boolean>(false)
  

    //call shortlist api based on userId
    useEffect(() => {
            const fetchSortListData = async () => {
                startLoading();
                const response: IApiResponse<ISHortlistData> = await fetchData(`${apiUrls['ShortList']}${userData}`);
                handleApiResponse(response, (sortListData) => {
                    stopLoading();
                    localStorage.removeItem('removedIds');
                    setPlayerShortListData(sortListData?.shortListPlayers)
                    setClubShortListData(sortListData?.shortListTeams)
                    if(sortListData?.playerIds?.length > 0){
                        setSortListPlayerIds(sortListData?.playerIds)
                    }
                    else{
                        setIsShortListEmpty(true)
                        setDisplayNotification(true);
                        setNotificationContent(
                        <div className="notification">
                            <p className='sortlist-notofication-content'>
                                <InfoOutlinedIcon className='icon' />
                                <LabelText className="squad-chart-tooltip notification-content">
                                    Short list currently empty.
                                </LabelText>
                            </p>
                        </div>
                        );
                    }
                    if(sortListData?.teamIds?.length > 0){
                        setSortListClubIds(sortListData?.teamIds)
                    }
                    else{
                        setIsclubEmpty(true)
                        setDisplayNotification(true);
                        setNotificationContent(
                        <div className="notification">
                            <p className='sortlist-notofication-content'>
                                <InfoOutlinedIcon className='icon' />
                                <LabelText className="squad-chart-tooltip notification-content">
                                    Short list currently empty.
                                </LabelText>
                            </p>
                        </div>
                        );
                    }
                }, (error) => {
                    stopLoading();
                    console.error('Error fetching shortlist data :', error);
                });
                };
            fetchSortListData();
    }, [userData]);

                        
    useEffect(()=>{
        if(showPlayerComparison){
            navigate(`/shortlists/playercomparison/${userData}`, { state: { playerIds: sortListPlayerIds, isFromSortList: true, benchMarkPlayerId: null } });
        }
        if(showClubComparison){
            navigate(`/shortlists/clubcomparison/${userData}`, { state: { teamIds: sortListClubIds, isFromSortList: true, benchMarkPlayerId: null } })
        }
    },[showPlayerComparison,showClubComparison])

  return (
    <>
      {loading && <LoadingSpinner />}
      {/* {showPlayerComparison && <PlayerComparisionTool playerIDS={sortListPlayerIds} FromSortListPage={true} />} */}
            <MainContainer active={props.toggle} isSubSidebarOpen={props.isSubSidebarOpen} className='player-search-results main-container player-detail-page'>
                <PageHeader title='Shortlists'/>
                    <div className='shortlists-categories-container'>
                        <div className='shortlists-categories-content' onClick={()=>{setShowPlayerComparison(true)}}>
                            <LabelText className='player-detail-family-name'>Players</LabelText>
                            
                            {isShortListEmpty ? (
                                <div className='shortlist-empty'>
                                    <LabelNumber className='chart-content-number'>Shortlist empty</LabelNumber>
                                </div>
                            ):(
                                <div className='list-content'>
                                    {playerShortLiastData?.slice(0, 11).map((player: IShortlistPlayers, index: number) => (
                                            <PlayerAvatar 
                                                className="categories-avatar" 
                                                backgroundImage={player.imageDataURL} 
                                            />
                                    ))}
                                    {playerShortLiastData?.length! > 11 && (
                                            <div className='counter-icon'>
                                                <LabelText className='profile-name'>+{playerShortLiastData?.length! - 11}</LabelText>
                                            </div>
                                    )}
                                </div>
                            )}
                           
                        </div>
                        <div className='shortlists-categories-content'  onClick={()=>{setShowClubComparison(true)}}>
                            <LabelText className='player-detail-family-name'>Clubs</LabelText>
                            {isclunEmty ? (
                                <div className='shortlist-empty'>
                                    <LabelNumber className='chart-content-number'>Shortlist empty</LabelNumber>
                                </div>
                            ):(
                                <div className='list-content'>
                                    {clubShortLiastData?.slice(0, 11).map((player: IShortlistPlayers, index: number) => (
                                            <img 
                                                // className="categories-avatar" 
                                                width={64}
                                                height={64}
                                                src={player.imageDataURL} 
                                            />
                                    ))}
                                    {clubShortLiastData?.length! > 11 && (
                                            <div className='counter-icon'>
                                                <LabelText className='profile-name'>+{clubShortLiastData?.length! - 11}</LabelText>
                                            </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
            </MainContainer>
        

    </>
  );
}

export default SortListComponent